var __rspack_ns_object = JSON.parse('{"Measurements":"Medições","Studies":"Exames"}')